import { IRectangle, Link, List } from '@fluentui/react';
import { ShortWebsiteModel } from '../../websites/models/WebsiteModel';

type PopularWebsiteProps = {
    list: ShortWebsiteModel[];
}

export default function PopularWebsiteView({ list }: PopularWebsiteProps) {
    var columnCount: number = 2;

    const getItemCountForPage = (itemIndex?: number, surfaceRect?: IRectangle): number => {
        if (itemIndex === 0) {
            let count = 2;

            const width = surfaceRect?.width ?? 0;
            count = Math.trunc(width / 220);

            if (count < 2) count = 2;

            columnCount = count;
        }

        return list.length;
    }

    const onRenderCell = (website?: ShortWebsiteModel, index?: number, isScrolling?: boolean) => {
        if (!website) {
            return <div></div>;
        }

        const width = (100 / columnCount) + '%';

        return <div key={website.id} className="list-grid-tile p-10" style={{ width: width }}>
            <Link href={website.domain} target="_blank">
                <div className={"box pv-10 center"}>
                    {website.name}
                </div>
            </Link>
        </div>;
    }

    return <div>
        <List
            key={columnCount}
            items={list}
            onRenderCell={onRenderCell}
            getItemCountForPage={getItemCountForPage} />
    </div>;
}